import { render, staticRenderFns } from "./ArticleOperationGroups.vue?vue&type=template&id=4f653308&scoped=true&"
import script from "./ArticleOperationGroups.vue?vue&type=script&lang=js&"
export * from "./ArticleOperationGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f653308",
  null
  
)

export default component.exports